import { forwardRef } from 'react';
import { StyledLi, StyledListContainer, StyledGridContainer } from './styles.js';
import { jsxs, jsx } from '@emotion/react/jsx-runtime';

const DragItemContainer = forwardRef(({
  children,
  color,
  content,
  dragOverlay,
  fadeIn,
  index,
  sorting,
  style,
  transform,
  transition
}, ref) => {
  return jsxs(StyledLi, {
    ref: ref,
    dragOverlay: dragOverlay,
    fadeIn: fadeIn,
    sorting: sorting,
    style: {
      ...style,
      transition: [transition, style === null || style === void 0 ? void 0 : style.transition].filter(Boolean).join(', '),
      '--translate-x': transform ? `${Math.round(transform.x)}px` : undefined,
      '--translate-y': transform ? `${Math.round(transform.y)}px` : undefined,
      '--scale-x': transform !== null && transform !== void 0 && transform.scaleX ? `${transform.scaleX}` : undefined,
      '--scale-y': transform !== null && transform !== void 0 && transform.scaleY ? `${transform.scaleY}` : undefined,
      '--index': index,
      '--color': color
    },
    children: [content, children]
  });
});
const ListContainer = forwardRef(({
  children,
  columns = 1,
  customItem,
  horizontal,
  style
}, ref) => {
  return jsx(StyledListContainer, {
    ref: ref,
    horizontal: horizontal,
    customItem: customItem,
    style: {
      ...style,
      '--columns': columns
    },
    children: children
  });
});
function GridContainer({
  children,
  columns
}) {
  return jsx(StyledGridContainer, {
    style: {
      '--col-count': columns
    },
    children: children
  });
}

export { DragItemContainer, GridContainer, ListContainer };
